// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__izjCv","selects":"Documents_selects__3VxIs"};